/**
 * Detect flex gap support,
 * and add a class to the document element if there is no support.
 *
 * This is based on the detection script in Modernizr:
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/css/flexgap.js
 */

// Add an element with row-gap
const flex = document.createElement("div");
flex.style.display = "flex";
flex.style.flexDirection = "column";
flex.style.rowGap = "1px";

// Put two things in it
flex.appendChild(document.createElement("div"));
flex.appendChild(document.createElement("div"));

// Append to the DOM temporarily and check its scroll height
document.documentElement.appendChild(flex);
const isSupported = flex.scrollHeight === 1;
flex.remove();

// Set a class if there's no support
if (!isSupported) document.documentElement.classList.add("no-flex-gap");
